import { CheckoutSummaryNeedAssistance } from 'components/views/pages/Checkout/CheckoutSummary/components/CheckoutSummaryNeedAssistance';
import { CheckoutSummaryProperty } from 'components/views/pages/Checkout/CheckoutSummary/components/CheckoutSummaryProperty';
import { CheckoutSummaryGrid } from 'components/views/pages/Checkout/CheckoutSummary/styles';
import { useScreenWidth } from 'webHooks/useScreenWidth';

interface Args {
  pid: string | undefined;
  children: React.ReactNode;
}

export const SummaryLayout = ({ pid, children }: Args) => {
  const { isMd } = useScreenWidth();

  return (
    <>
      <CheckoutSummaryGrid container $isMd={isMd}>
        <CheckoutSummaryProperty pid={pid} />
        {children}
        <CheckoutSummaryNeedAssistance />
      </CheckoutSummaryGrid>
    </>
  );
};
